import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemainderComponent } from './component/remainder.component';


@NgModule({
    declarations: [RemainderComponent],
    imports: [
        CommonModule
    ]
})
export class RemainderModule {
}
